import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, SaveFormModule, SectionDivider } from '@domain-group/suit-theme'

import type { ProviderPriceListItemModel } from '@models/types'

import useProviderPriceListItemOptions from '@hooks/useProviderPriceListItemOptions'

import PriceListItemOption from './PriceListItemOption'

interface PriceListItemOptionsProps {
  callbacks: {
    showCreateOrEditProviderPriceListItemOptionModal: (payload: object) => void,
    showCreateOrEditProviderPriceListItemOptionValueModal: (payload: object) => void,
  },
  isMaster: boolean,
  providerPriceListItem: ProviderPriceListItemModel,
}

const PriceListItemOptions = (props: PriceListItemOptionsProps) => {
  const {
    callbacks: {
      showCreateOrEditProviderPriceListItemOptionModal,
      showCreateOrEditProviderPriceListItemOptionValueModal,
    },
    isMaster,
    providerPriceListItem,
  } = props

  const priceListItemOptionsPayload = useProviderPriceListItemOptions({
    filters: {
      provider_price_list_item_id: providerPriceListItem.id,
    },
    performHttpRequests: false,
  })

  const {
    filteredProviderPriceListItemOptions,
    hasFilteredProviderPriceListItemOptions,
  } = priceListItemOptionsPayload

  if (!hasFilteredProviderPriceListItemOptions && !isMaster){
    return null
  }

  return (
    <>
      <SectionDivider boxProps={{ marginBottom: 'large' }}>Options</SectionDivider>

      {filteredProviderPriceListItemOptions.map(priceListItemOption => (
        <PriceListItemOption
          callbacks={{
            showCreateOrEditProviderPriceListItemOptionValueModal,
          }}
          isMaster={isMaster}
          key={priceListItemOption.id}
          providerPriceListItemOption={priceListItemOption}
        />
      ))}

      {isMaster && (
        <SaveFormModule>
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => showCreateOrEditProviderPriceListItemOptionModal({
              providerPriceListItemOption: {
                hidden: false,
                provider_price_list_item_id: providerPriceListItem.id,
              },
            })}
            size="small"
          >
            Add Option
          </Button>
        </SaveFormModule>
      )}
    </>
  )
}

export default PriceListItemOptions
